import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { BreakingTicker } from '@/components/news/BreakingTicker';
import { CategoryRail } from '@/components/news/CategoryRail';
import { FeedEmptyState } from '@/components/news/FeedEmptyState';
import { NewsFeedCard } from '@/components/news/NewsFeedCard';
import { Seo } from '@/components/seo/Seo';
import { appConfig } from '@/config/app';
import { getCategoryBySlug } from '@/config/categories';
import {
  getBreakingNews,
  getCategorySummaries,
  getNewsByCategory
} from '@/services/newsRepository';
import { useInfiniteFeed } from '@/hooks/useInfiniteFeed';

export function CategoryFeedPage() {
  const { categorySlug = '' } = useParams();
  const category = getCategoryBySlug(categorySlug);
  const articles = useMemo(() => (category ? getNewsByCategory(category.name) : []), [category]);
  const { visibleItems, sentinelRef, hasMore } = useInfiniteFeed(articles, 3);

  if (!category) {
    return <Navigate to="/categorias" replace />;
  }

  const canonical = `${appConfig.siteUrl}/categoria/${category.slug}`;

  return (
    <>
      <Seo
        title={`${category.name} | El Divergente`}
        description={category.description}
        canonical={canonical}
        keywords={[category.name, 'Puerto San Julián', 'Santa Cruz']}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: `${category.name} | El Divergente`,
          url: canonical,
          description: category.description
        }}
      />
      <BreakingTicker articles={getBreakingNews()} />
      <CategoryRail categories={getCategorySummaries()} />
      {visibleItems.length > 0 ? (
        <section className="snap-y snap-mandatory scroll-smooth">
          {visibleItems.map((article) => (
            <NewsFeedCard key={article.id} article={article} />
          ))}
          <div ref={sentinelRef} className="grid h-24 place-items-center text-sm text-white/38">
            {hasMore ? 'Cargando más' : 'Fin del feed'}
          </div>
        </section>
      ) : (
        <FeedEmptyState
          title={`Sin noticias de ${category.name}`}
          description="El feed público se actualizará cuando haya publicaciones en esta sección."
        />
      )}
    </>
  );
}
